import React from 'react';
import _ from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import Header from './Header';
import ClickableImage from './ClickableImage';
import './LabelClass.css';
import { removeImage } from '../../redux/actions/labelClasses';
import { reloadExamples } from '../../shared/image_classifier';

var LabelClass = function LabelClass(_ref) {
  var id = _ref.id;
  var dispatch = useDispatch();

  var removeExample = function removeExample(index) {
    dispatch(removeImage(labelClass.id, index)).then(reloadExamples(labelClass));
  };

  var labelClass = useSelector(function (state) {
    return _.find(state.labelClasses.list, {
      id: id
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "panel--round class-panel"
  }, /*#__PURE__*/React.createElement(Header, {
    labelClass: labelClass
  }), /*#__PURE__*/React.createElement("div", {
    className: "panel--round__body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "panel--round__body___subheader"
  }, /*#__PURE__*/React.createElement("label", null, "Items: ", labelClass.images.length)), /*#__PURE__*/React.createElement("div", {
    className: "flex-row-container flex-wrap"
  }, labelClass.images.map(function (image, index) {
    return /*#__PURE__*/React.createElement(ClickableImage, {
      key: index,
      index: index,
      image: image,
      labelClass: labelClass,
      removeExample: removeExample
    });
  }))));
};

export default LabelClass;